import { SignIn, useUser } from "@clerk/clerk-react"
import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/(auth)/auth")({
  component: RouteComponent,
})

function RouteComponent() {
  const { isSignedIn, isLoaded } = useUser()

  // Show loading state while checking authentication
  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Declaratively redirect if authenticated
  if (isSignedIn) {
    return <Navigate to="/app" replace />
  }

  // Show Clerk's SignIn component (handles both sign-in and sign-up)
  return (
    <div className="flex items-center justify-center min-h-screen">
      <SignIn forceRedirectUrl="/app" signUpUrl="/sign-up" />
    </div>
  )
}
